import Blue from "../core";

new Blue({
	name: 'Form Validate',
	selector: ".form--validate",
	setup(form) {
		this.$validate(form);
	}
});

new Blue({
	name: 'Conditionally Disabled Text Input',
	selector: "input[type=checkbox][data-disabled-input-control]",
	setup(checkbox) {
		const input = document.querySelector("#" + checkbox.getAttribute("data-disabled-input-control"));
		let val;
		
		// When checkbox is checked, input is required and enabled
		// When checkbox is unchecked, input is not required and disabled
		const checkboxLogic = () => {
			if (checkbox.checked) {
				input.value = val;
				input.disabled = false;
				input.setAttribute("required", "true");
			} else {
				val = input.value;
				input.disabled = true;
				input.setAttribute("required", "false");
				input.value = "";
			}
		}

		this.$addEvents(checkbox, "input", checkboxLogic);

		// For checkboxes that start out checked, set attributes on page load
		checkboxLogic();
	}
});


new Blue({
	name: 'Show Text Radio',
	selector: ".radio-message",
	setup(radios) {
		const triggerOn = radios.querySelector('.input-trigger-on');
		const triggerOff = radios.querySelector('.input-trigger-off');
		const message = radios.querySelector('.input-trigger-message');
		
		this.$addEvents(triggerOn, "click", () => {
			message.classList.add("is-visible");
		});
		this.$addEvents(triggerOff, "click", () => {
			message.classList.remove("is-visible");
		});
	}
});